<template>
    <div class="seed-card">
        <div class="blog-author mb-0" :class="isRed ? 'bg-red ' : ''">
            <div class="author">
                <div class="info">
                    <h5 class="mb-0 bold" :class="isRed ? 'white' : ''"><u>{{ project.name }}</u></h5>
                    <p class="black" :class="isRed ? 'white' : ''">{{ getProjectCategory }}</p>
                </div>
                <div class="author-thumb">
                    <img :src="`${img_base}${getIcon}`" alt="avatar">
                </div>
            </div>
        </div>
        <div class="seed-card-body text-center">
            <span class="h2 tasa mb--15 bold">{{ (project.anual_interest * 100).toFixed(2) }}%</span><span
                class="black">tasa anual</span>
            <div class="mb--20">
                <p class="bold mb-2">Avance en Fondeo</p>
                <div class="progress-bar" :class="isRed ? 'red' : ''">
                    <h6 class="mb-0 bold">{{ getInvestedPercentage(project) }}% de {{ mxnFormat(project.financed_amount) }}
                    </h6>
                </div>
            </div>
            <div class="row mb--40">
                <div class="col-6">
                    <p class="bold mb-2">Plan en años</p>
                    <div class="chip plan-chip">
                        <h6 class="white mb-0 bold">{{ (project.term / 12) }}</h6>
                    </div>
                </div>
                <div class="col-6">
                    <p class="bold mb-2">Calificación</p>
                    <div class="chip qualification-chip">
                        <h6 class="mb-0 bold">{{ project.qualification }}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from '@mixins/formatHelper';
export default {
    name: "SeedCard",
    props: ["isRed", "icon", "project"],
    mixins: [formatHelper],
    data() {
        return {
            img_base: "https://cdn.redgirasol.com/nuevo_portal/icons/icon-"
        }
    },
    methods: {
        getInvestedPercentage(project) {
            return ((project.invested * 100) / project.financed_amount).toFixed(0);
        }
    },
    computed: {
        getProjectCategory() {
            let name = "No definido"
            if (this.project.category) {
                name = this.project.category.name;
            }

            return name;
        },
        getIcon() {
            let icon = "energia.png"

            // sí es de ecotecnologia y no tiene programa
            if(this.project.loan_type == 1) {
                if(this.isRed) {
                    icon = "energia-red.png";
                } else {
                    icon = "ecotecnologia.png";
                }
            } else if(this.project.loan_type == 4)  {
                // capital de trabajo
                icon = "pyme.png";
            } else if (this.project.loan_type == 5) {
                icon = "personal.png";
            }

            return icon;




            // TODO-DELETE
        //     if (this.project.category) {
        //         if(this.isRed) {
        //             icon = "energia-red.png"
        //         } else {
        //             name = this.project.category.name;
        //             switch(name) {
        //                 case "Proyecto solar térmico": icon = "energia.png"; break; 
        //                 case "Paisajes sostenibles": icon = "biodiversidad.png"; break; 
        //                 case "Certificación de bonos de carbono": icon = "biodiversidad.png"; break; 
        //                 case "Integrador de proyectos": icon = "construccion.png"; break; 
        //                 case "Mayorista": icon = "construccion.png"; break; 
        //                 case "Proyecto solar fotovoltaico": icon = "energia.png"; break; 
        //                 case "Proyecto de eco-tecnologías": icon = "energia.png"; break; 
        //                 case "Eliminación de residuos": icon = "residuos.png"; break; 
        //                 case "Diseño bioclimático": icon = "residuos.png"; break; 
        //                 case "Producción de materiales": icon = "impact-construccion.png"; break; 
        //                 case "Cadena de valor solar": icon = "energia.png"; break; 
        //                 case "Agricultura": icon = "impact-agronegocios.png"; break; 
        //                 case "Reuso": icon = "impact-3r.png"; break; 
        //                 case "Reciclaje": icon = "impact-3r.png"; break; 
        //                 case "Vehículos eléctricos": icon = "movilidad.png"; break; 
        //                 case "Apicultura": icon = "impact-agronegocios.png"; break; 
        //                 case "Ecoturismo": icon = "impact-agronegocios.png"; break; 
        //                 case "Internet": icon = "energia.png"; break; 
        //                 case "Salud financiera": icon = "energia.png"; break; 
        //                 default: icon = "energia.png";
        //             }
        //         }
        //     }

        //     return icon;
        }
    }
}

</script>

<style scoped>
.tasa {
    margin-right: 8px;
}

.blog-author {
    border-radius: 25px 25px 0px 0px !important;
    background: var(--gradient-rg-green);
    border: 2px solid var(--color-black);
    padding: 20px !important;
    min-height: 10rem;

}

.blog-author.bg-red {
    background: var(--gradient-rg-red) !important;
    color: var(--color-white);
}

.info {
    margin-left: 10px !important;
}

.seed-card-body {
    border: 2px solid var(--color-black);
    border-radius: 0px 0px 25px 25px;
    border-top: none;
    padding-top: 1rem;
}

.progress-bar {
    background-color: var(--color-primary);
    margin-left: 2rem;
    margin-right: 2rem;
    border-radius: 10px;
    padding: 12px;
}

.progress-bar.red {
    background-color: var(--color-red);
    color: var(--color-white);

}

.progress-bar.red h6 {
    color: var(--color-white) !important;

}

.chip {
    margin-left: 2rem;
    margin-right: 2rem;
    border-radius: 10px;
    padding: 12px;
}

.plan-chip {
    background-color: var(--color-black);
    color: var(--color-white);
}

.qualification-chip {
    background-color: var(--color-accent1);
    color: var(--color-black) !important;
}

.blog-author img {
    max-width: 75%;
    height: auto;
    vertical-align: middle;
    float: right;
}

@media only screen and (max-width: 991px) { 
    .blog-author img{
        display: none !important;
    }
}
</style>